import type { StoreApi, UseBoundStore } from 'zustand';
import { createStore, type StoreState } from './Store';

export type DiffLayout = 'inline' | 'side-by-side';
export type SearchResult = { path: string; line: number; column: number; match: string; text: string }

const defaults = {
  session_id: null as number | null,
  message_id: null as number | null,
  file_path: null as string | null,
  version_id: null as number | null,
  versions_tagged: true as boolean,
  versions_major: true as boolean,
  filesystem_id: '' as string,
  agent_id: null as string | null,
  tracking: false,
  prompt: null as string | null,
  speech_enabled: true,
  diff_before_version_id: null as number | null,
  diff_after_version_id: null as number | null,
  diff_layout: 'inline' as DiffLayout,
  diff_file_path: null as string | null,
  prompts_tagged: false as boolean,
  search_result: null as SearchResult | null,
};

type SelectionFields = typeof defaults;

type SelectionState = StoreState<SelectionFields>;

export const useSelectionStore: UseBoundStore<StoreApi<SelectionState>> = createStore(defaults, {
  persist: true,
  persistKey: 'dashboard-selection-store',
  hooks: {
    beforeSet: (draft, updates) => {
      if ('session_id' in updates && updates.session_id !== draft.session_id) {
        draft.message_id = null;
      }
    },
  },
});
